import { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import OTPInput from 'react-otp-input';
import { Link } from 'react-router-dom';
import CkycCard from './ckycCard';
import CkycDetailsCard from './CkycDetailsCard';

const CKYC = (props) => {
    const formRef = useRef(null);
    const tabStatus = props.urlparams.params.status;
    const frompath = props?.urlparams?.params?.frompath;
    const isAdmin = props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
    const [customerId, setCustomerId] = useState(null);
    const [selectedIdentifier, setSelectedIdentifier] = useState(_enum.IDENTIFIER_TYPE.find(item => item.key === "PAN") || _enum.IDENTIFIER_TYPE[0]);
    const [validationError, setValidationError] = useState(null);
    const [ckycData, setCkycData] = useState(null);
    const [customerCkyc, setCustomerCkyc] = useState(null);
    const [showCkycModal, setShowCkycModal] = useState(false);
    const [showCkycOtpInput, setShowCkycOtpInput] = useState(false);
    const [ckycOtpValue, setCkycOtpValue] = useState("");
    const [ckycDetails, setCkycDetails] = useState(null);

    const closeCkycModal = () => {
        setShowCkycModal(false);
        setShowCkycOtpInput(false);
        setCkycOtpValue("");
    };

    const handleCkycOtpVerify = () => {
        if (!ckycOtpValue || ckycOtpValue.length < 6) {
            swal2.fire({
                title: "Please enter a valid OTP",
                icon: "error",
                iconColor: "#FF4D4D",
            });
            return;
        }

        const payload = {
            customerId: customerId,
            otp: ckycOtpValue
        };

        props.apis.apiUnderWriterSubmitCkycOtp(payload)
            .then((res) => {
                if (res) {
                    swal2.fire({
                        title: "CKYC Generated Successfully",
                        icon: "success",
                    });
                    if (res.result) {
                        setCkycDetails(res.result);
                    }
                    closeCkycModal();
                    getUnderwriterInfo();
                }
            });
    };

    const handleChange = (value) => {
        let val = value[0]?.key || "";
        const selected = _enum.IDENTIFIER_TYPE.find((item) => item.key === val) || _enum.IDENTIFIER_TYPE[0];
        setSelectedIdentifier(selected);
        setValidationError(null);
        console.log({ val });
    };

    const handleSubmit = () => {

        const data = formRef.current?.form?.current?.getData?.() || {};
        const identifierVal = data.identifier || "";

        if (!identifierVal || identifierVal.trim() === "") {
            setValidationError("This field is required");
            return;
        }

        if (selectedIdentifier) {
            if (selectedIdentifier.pattern && !new RegExp(selectedIdentifier.pattern).test(identifierVal)) {
                setValidationError(selectedIdentifier.invalidmessage || "Invalid format");
                return;
            }
            if (selectedIdentifier.minLength && identifierVal.length < selectedIdentifier.minLength) {
                setValidationError(selectedIdentifier.invalidmessage || "Invalid format");
                return;
            }
            if (selectedIdentifier.maxLength && identifierVal.length > selectedIdentifier.maxLength) {
                setValidationError(selectedIdentifier.invalidmessage || "Invalid format");
                return;
            }
        }

        setValidationError(null);

        const payload = {
            customerId,
            identifierType: data.identifierType,
            identifier: data.identifier
        }
        console.log({ payload });
        props.apis
            .apiUnderWriterCKYCSearch(payload)
            .then((res) => {
                if (res) {
                    if (res?.status === "INVALID") {
                        swal2.fire({
                            title: res?.error,
                            icon: "error",
                            iconColor: "#FF4D4D",
                        });
                        setCkycData(null);
                        setCkycDetails(null);
                        formRef.current?.form?.current?.reset?.();
                    } else {
                        setCkycData(res?.result[0] || null);
                        setCkycDetails(null);
                    }
                }
            });

    };

    const handleCkycMobileSubmit = (e, data) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();

        const payload = {
            customerId,
            mobileNumber: data?.mobileNumber,
        }
        console.log({ payload });

        props.apis
            .apiUnderWriterDownloadCkycRequest(payload)
            .then((res) => {
                if (res) {
                    setShowCkycOtpInput(true);
                }
            });
    };

    const handleGenerateCKYC = () => {
        setShowCkycModal(true);
        setShowCkycOtpInput(false);
        setCkycOtpValue("");
    };

    const getUnderwriterInfo = () => {
        props.apis
            .apiGetUnderWriterApplicationDetails({
                applicationNumber: props.urlparams.params.id,
            })
            .then((res) => {
                if (res) {
                    setCustomerId(res?.customerId);
                    setCustomerCkyc(res?.customer?.customerCkyc)
                }
            });
    };

    useEffect(() => {
        getUnderwriterInfo();
    }, []);
    return (
        <>
            {!isAdmin && !customerCkyc &&
                <div className="card p-4">
                    <div className="flex_card_outer">
                        <div className="flex_card">
                            <h4 className="title">Search CKYC using any one identifier</h4>
                            <AppForm ref={formRef} onSubmit={handleSubmit} noValidate className="row">
                                <div className="col-12 col-md-4">
                                    <AppInput
                                        type="select"
                                        name="identifierType"
                                        label="Identifier Type"
                                        options={_enum.IDENTIFIER_TYPE}
                                        defaultValue={["PAN"]}
                                        onChange={handleChange}
                                        disabled={!!ckycDetails}
                                    />
                                </div>
                                <div className="col-12 col-md-4">
                                    <AppInput
                                        type="text"
                                        name="identifier"
                                        label={selectedIdentifier?.inputLabel || "Identifier Number"}
                                        errorMessage={validationError ? { name: "identifier", message: validationError } : null}
                                        onChange={() => setValidationError(null)}
                                        disabled={!!ckycDetails}
                                        required
                                    />
                                </div>
                                <div className="col-12 col-md-4 d-flex align-items-center mt-3">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={!!ckycDetails}
                                    >
                                        Search
                                    </button>
                                </div>
                            </AppForm>
                        </div>
                    </div>
                </div>
            }

            {(isAdmin && !customerCkyc) && <div className='card p-4 text-center'><h4 className='m-0'>No CKYC Data Found</h4></div>}

            {customerCkyc ? (
                <>
                    <CkycCard
                        ckycData={{
                            name: customerCkyc.fullName || customerCkyc.fullPayload?.personal_details?.full_name,
                            ckyc_id: customerCkyc.ckycNo || customerCkyc.fullPayload?.personal_details?.ckyc_no,
                            father_name: customerCkyc.fatherName || customerCkyc.fullPayload?.personal_details?.father_fullname,
                            ckyc_ref_id: customerCkyc.ckycReferenceId || customerCkyc.fullPayload?.personal_details?.ckyc_reference_id,
                            age: customerCkyc.age,
                            kyc_date: customerCkyc.kycDate || customerCkyc.fullPayload?.personal_details?.kyc_date,
                            mobile_code: customerCkyc.fullPayload?.personal_details?.mob_code,
                            mob_num: customerCkyc.fullPayload?.personal_details?.mob_num || customerCkyc.mobileNumber,
                            remarks: customerCkyc.fullPayload?.personal_details?.remarks,
                        }}
                        handleGenerateCKYC={handleGenerateCKYC}
                        isCkycGenerated={true}
                        hideGenerateButton={true}
                    />
                    <CkycDetailsCard details={customerCkyc.fullPayload} />
                </>
            ) : (
                <>
                    {ckycData && <CkycCard ckycData={ckycData} handleGenerateCKYC={handleGenerateCKYC} isCkycGenerated={!!ckycDetails} />}
                    {ckycDetails && <CkycDetailsCard details={ckycDetails} />}
                </>
            )}
            {/* CKYC MODAL */}
            <Modal
                show={showCkycModal}
                onHide={closeCkycModal}
                centered
                backdrop="static"
                className="consent_otp_modal"
            >
                <Modal.Header
                    closeButton
                    className="border-0 py-4 d-flex align-item-start"
                >
                    <h2>CKYC Verification</h2>
                </Modal.Header>
                <Modal.Body className="pt-0">
                    <div className="row g-3 mb-4">
                        <AppForm onSubmit={handleCkycMobileSubmit}>
                            <AppInput
                                type="text"
                                name="mobileNumber"
                                label="Enter CKYC Registered Mobile No."
                                disabled={showCkycOtpInput}
                                placeholder="Enter 10 digit mobile number"
                                required
                            />
                            <div className={`col-12 d-flex align-items-center justify-content-end ${showCkycOtpInput ? "d-none" : ""}`}>
                                <button
                                    type="button"
                                    className="btn btn-primary-lite"
                                    onClick={closeCkycModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary ms-3"
                                >
                                    Generate
                                </button>
                            </div>
                        </AppForm>
                        {showCkycOtpInput && (
                            <>
                                <div className="col-12 d-flex flex-column">
                                    <div className="">
                                        <h3 className="">OTP to verify</h3>
                                        <p className="">We have sent an OTP to your mobile no.</p>
                                    </div>
                                    <div className="d-flex">
                                        <OTPInput
                                            value={ckycOtpValue}
                                            onChange={setCkycOtpValue}
                                            separator={<span>-</span>}
                                            renderInput={(props) => <input {...props} />}
                                            numInputs={6}
                                            shouldAutoFocus={true}
                                            isInputNum={true}
                                            containerStyle="otp_container small p-0"
                                        />
                                    </div>
                                </div>
                                <div className="col-12 d-flex align-items-center justify-content-end mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary-lite"
                                        onClick={closeCkycModal}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary ms-3"
                                        onClick={handleCkycOtpVerify}
                                    >
                                        Verify
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </Modal.Body>
            </Modal>

            {!isAdmin && (
                <div className="nav_container mt-5">
                    <Link
                        to={`/app/loanapplications?activetab=${tabStatus}`}
                        className="btn btn-primary-lite me-3"
                    >
                        Cancel
                    </Link>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={(...args) =>
                            props.changeTab(...args, "backgroundverification")
                        }
                    >
                        Next
                    </button>
                </div>
            )}
        </>
    )
}

export default constore(CKYC)